import axios from 'axios';

const baseUrl = '/';

const axiosInstance = axios.create({
  baseURL: `${baseUrl}actions`,
});

export default axiosInstance;
